import React from "react";
import { MobileContainer } from "./styled";

const IsMobile = ({ children }) => {
  return <MobileContainer>{children}</MobileContainer>;
};

export default IsMobile;
